export function useCatalogSearch() {
  const route = useRoute()
  const router = useRouter()

  const search = computed(() => {
    return route.query.q || ''
  })

  const updateSearch = (q: string) => {
    router.push({
      query: {
        q,
        p: 1,
      },
    })
  }

  return {
    search,
    updateSearch,
  }
}
